import React from 'react';
import clsx from 'clsx';
import styles from './index.module.scss';

export interface CircleLoaderProps {
  className?: string;
}

function CircleLoader(props: CircleLoaderProps) {
  return (
    <div className={clsx(styles.root, props.className)}>
      <div className={styles.circleLoader} />
    </div>
  );
}

export default CircleLoader;
